import { render, staticRenderFns } from "./testRobot.vue?vue&type=template&id=63c3a384&"
import script from "./testRobot.vue?vue&type=script&lang=js&"
export * from "./testRobot.vue?vue&type=script&lang=js&"
import style0 from "./testRobot.vue?vue&type=style&index=0&id=63c3a384&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports